import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { QRCodeToDataURLOptions, toDataURL } from 'qrcode';

@Component({
  selector: 'app-qr-code',
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss']
})
export class QrCodeComponent implements OnChanges {

  @Input()
  data: string | null = null;

  @Input()
  config: QRCodeToDataURLOptions | null = null;

  dataURL: string | null = null;

  constructor () { }

  ngOnChanges (changes: SimpleChanges) {

    if (changes['data']) {
      this.handleDataChange();
    }
  }

  private handleDataChange () {

    if (!this.data) {

      this.dataURL = null;
      return;
    }

    const canvas = document.createElement('canvas');

    toDataURL(canvas, this.data, this.config || undefined)
        .then(dataURL => this.dataURL = dataURL)
        .catch(err => console.log(err));
  }
}
